var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    id: "thanks-icon-svg",
    style: {
      verticalAlign: "middle",
      fill: "white",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M514.56 936.448c-6.656 0-13.312-2.56-17.92-7.68L355.84 788.48H35.84c-14.336 0-25.6-11.264-25.6-25.6V112.64c0-14.336 11.264-25.6 25.6-25.6h957.44c14.336 0 25.6 11.264 25.6 25.6v650.24c0 14.336-11.264 25.6-25.6 25.6h-320L532.48 928.768c-4.608 5.12-11.264 7.68-17.92 7.68zM61.44 737.28h305.152c6.656 0 13.312 2.56 17.92 7.68l130.048 130.048 130.048-130.048c4.608-4.608 11.264-7.68 17.92-7.68H967.68V138.24H61.44v599.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.68 458.24m-53.76 0a53.76 53.76 0 1 0 107.52 0 53.76 53.76 0 1 0-107.52 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M514.56 458.24m-53.76 0a53.76 53.76 0 1 0 107.52 0 53.76 53.76 0 1 0-107.52 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M770.56 458.24m-53.76 0a53.76 53.76 0 1 0 107.52 0 53.76 53.76 0 1 0-107.52 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/smsIcon.09b8300f1da09bf11e101d10d70d36be.svg";
export { ForwardRef as ReactComponent };